/**
 * @generated SignedSource<<6a634a810f91b517b5aaccebac55807e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getPdpEstimateSimilarSold_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"getHasEnoughSimilarSoldItems_viewer">;
  readonly " $fragmentType": "getPdpEstimateSimilarSold_viewer";
};
export type getPdpEstimateSimilarSold_viewer$key = {
  readonly " $data"?: getPdpEstimateSimilarSold_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"getPdpEstimateSimilarSold_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getPdpEstimateSimilarSold_viewer"
};

(node as any).hash = "347c2b222e4a4cb40a2a4e740d7027a5";

export default node;
